import React from 'react';
import debounce from 'lodash/debounce';
import get from 'lodash/get';
import { MARKETO_FORM_ID, MARKETO_FORM_MUNCHKIN_ID, MARKETO_FORM_URL } from '../containers/UpgradeForm/constants';
import './styles.css';

export const loadMarketoForm = (component) => {
  if (window.MktoForms2) {
    // eslint-disable-next-line no-undef
    window.MktoForms2.loadForm(MARKETO_FORM_URL, MARKETO_FORM_MUNCHKIN_ID, MARKETO_FORM_ID, (form) => {
      component.setState({ marketoForm: form, scriptsLoadedSuccessfully: true });
      form.addHiddenFields({ OptIn: false });
      form.addHiddenFields({ LeadSource: 'Information Request' });
      form.addHiddenFields({ Lead_Source_Most_Recent__c: 'Information Request' });
      form.addHiddenFields({ companyNameForm: '' });
      form.addHiddenFields({ formState: '' });
      form.addHiddenFields({ formCountry: '' });
    });
  }
};

const _submitMarketoForm = (viewer, state, campaignId, leadSource, onSuccess, addJobTopicField) => {
  const { marketoForm, firstName, lastName, emailAddress, phone, notes, jobLevel, jobTopic, optIn } = state;
  const newValues = ({
    Email: emailAddress,
    FirstName: firstName,
    LastName: lastName,
    Phone: phone,
    commentCapture: notes,
    OptIn: optIn,
    externalSourceCampaignId: campaignId,
    companyNameForm: viewer.institution.name || '',
    formCompanyName: viewer.institution.name || '',
    formCountry: viewer.institution.field_country || 'United States',
    formJobTitle: jobLevel,
    formState: get(viewer, 'institution.field_state_short_name'),
    formid: MARKETO_FORM_ID,
    munchkinId: MARKETO_FORM_MUNCHKIN_ID,
    LeadSource: `Information Request - ${leadSource}`,
    Lead_Source_Most_Recent__c: `Information Request - ${leadSource}`,
  });

  if (addJobTopicField) {
    newValues.topic = jobTopic;
  }

  if (marketoForm) {
    marketoForm.onSuccess((values, followUpUrl) => {
      marketoForm.getFormElem().hide();
      onSuccess();
      return false;
    });
    marketoForm.setValues(newValues);
    if (marketoForm.validate()) {
      marketoForm.submit();
    }
  }
};

export const submitMarketoForm = debounce(_submitMarketoForm, 1000, { leading: true });

export const renderMarketoForm = () => (
  <form id={`mktoForm_${MARKETO_FORM_ID}`} styleName="hidden" />
);

export default {
  loadMarketoForm,
  submitMarketoForm,
  renderMarketoForm,
};
